import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { getTaskTitleIdentifier } from '../../../../redux/tasks/taskEntities/selectors';
import { openTaskAction } from '../../../../redux/tasks/actions';

const OpenTaskDetailsMenuItem = ({ taskId }) => {
  const dispatch = useDispatch();

  const titleIdentifier = useSelector((state) => getTaskTitleIdentifier(state, { taskId }));

  const handleOpenTask = async () => {
    dispatch(openTaskAction(true, titleIdentifier, taskId));
  };

  return (
    <div onClick={handleOpenTask}>
      <FormattedMessage id="OPEN_TASK_DETAILS" defaultMessage="Open task details" />
    </div>
  );
};

export default OpenTaskDetailsMenuItem;
